export const REDUCER_KEY = 'product';
